import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'
import UpdateModal from './update-modal'
import { getBuildingObjectCode } from '@/utils/buildings'
import { useSelector } from 'react-redux'
import { selectActiveBuildingId } from '@/features/building/buildingSlice'
import { useGetBuildingsListByIdQuery } from '@/api'
import WidgetPaper from '@/components/WidgetPaper'
import TableRowsSkeleton from '@/components/TableRowsSkeleton'

// BuildingInfo.propTypes = {
//   buildings: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//       name: PropTypes.string,
//       address: PropTypes.string,
//       building_type_title: PropTypes.string,
//       parking_places: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//       is_active: PropTypes.bool,
//       exit_if_not_found: PropTypes.bool,
//       object_code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//       objectCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//       code: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
//     })
//   )
// }

const BuildingInfo = ({ref}) => {
  const activeBuildingId = useSelector(selectActiveBuildingId)
  const { data: buildingsList, isLoading, isFetching } = useGetBuildingsListByIdQuery(activeBuildingId)
  const showSkeleton = isLoading || (isFetching && !buildingsList)
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [currentId, setCurrentId] = useState()

  const handleEdit = (id) => () => {
    setCurrentId(id)
    setOpen(true)
  }

  return (
    <>
      <WidgetPaper
        ref={ref}
        title={t('building')}
      >
        <Stack>
          <TableContainer
            id="table-container"
            // component={Paper}
            sx={{ margin: 'auto' }}
          >
            <Table aria-label="simple table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>{t('object_code')}</TableCell>
                  <TableCell>{t('title')}</TableCell>
                  <TableCell align="right">{t('address')}</TableCell>
                  <TableCell align="right">{t('type')}</TableCell>
                  <TableCell align="right">
                    {t('number_of_parking_spaces')}
                  </TableCell>
                  <TableCell align="right">{t('status')}</TableCell>
                  <TableCell align="right">{t('open')}</TableCell>
                  <TableCell align="right">{t('actions')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {showSkeleton ? (
                  <TableRowsSkeleton rows={3} columns={8} />
                ) : (
                  buildingsList?.map((building) => (
                    <TableRow key={building?.id}>
                      <TableCell component="th" scope="row">
                        {getBuildingObjectCode(building) || t('not_specified')}
                      </TableCell>
                      <TableCell>{building?.name}</TableCell>
                      <TableCell align="right">
                        {building?.address}
                      </TableCell>
                      <TableCell align="right">
                        {building?.building_type_title}
                      </TableCell>
                      <TableCell align="right">
                        {building?.parking_places}
                      </TableCell>
                      <TableCell align="right">
                        {building?.is_active
                          ? t('actively')
                          : t('inactively')}
                      </TableCell>
                      <TableCell align="right">
                        {building?.exit_if_not_found ? t('yes') : t('no')}
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title={t('edit')}>
                          <IconButton
                            sx={{ mr: 2 }}
                            id="menu"
                            size="small"
                            aria-label="edit"
                            onClick={handleEdit(building?.id)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </WidgetPaper>
      <UpdateModal
        open={open}
        currentId={currentId}
        onClose={() => setOpen(false)}
        canEditActive={false}
      />
    </>
  )
};

export default BuildingInfo
